import React from 'react';
import Icon from '../../../components/AppIcon';

const MessageStats = ({ stats }) => {
  // Calculate aggregate stats
  const totalViews = stats.reduce((sum, stat) => sum + (stat.total_views || 0), 0);
  const totalDismissals = stats.reduce((sum, stat) => sum + (stat.total_dismissals || 0), 0);
  const totalClicks = stats.reduce((sum, stat) => sum + (stat.total_cta_clicks || 0), 0);
  const activeMessages = stats.filter(stat => stat.active).length;

  const statCards = [
    {
      label: 'Active Messages',
      value: activeMessages,
      icon: 'MessageSquare',
      color: 'text-blue-600 dark:text-blue-400',
      bg: 'bg-blue-100 dark:bg-blue-900/30'
    },
    {
      label: 'Total Views',
      value: totalViews.toLocaleString(),
      icon: 'Eye',
      color: 'text-green-600 dark:text-green-400',
      bg: 'bg-green-100 dark:bg-green-900/30'
    },
    {
      label: 'Total Dismissals',
      value: totalDismissals.toLocaleString(),
      icon: 'X',
      color: 'text-amber-600 dark:text-amber-400',
      bg: 'bg-amber-100 dark:bg-amber-900/30'
    },
    {
      label: 'CTA Clicks',
      value: totalClicks.toLocaleString(),
      icon: 'MousePointerClick',
      color: 'text-purple-600 dark:text-purple-400',
      bg: 'bg-purple-100 dark:bg-purple-900/30'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat.label}</p>
              <p className="text-2xl font-bold text-foreground">{stat.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${stat.bg}`}>
              <Icon name={stat.icon} size={24} className={stat.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageStats;
